import { render, staticRenderFns } from "./funnelChart.vue?vue&type=template&id=c0565900&"
import script from "./funnelChart.vue?vue&type=script&lang=js&"
export * from "./funnelChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports